import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { SettingsService } from '@app/_services/settings.service';

@Component({
    selector: 'app-support-instructions',
    imports: [
        CommonModule,
    ],
    templateUrl: './support-instructions.component.html',
    styleUrl: './support-instructions.component.scss'
})

export class SupportInstructionsComponent {

  constructor(
    public dialogRef: MatDialogRef<SupportInstructionsComponent>,
    public ss: SettingsService
  ) { }

  closeDialog() {
    this.dialogRef.close();
  }
}
